import styled from "styled-components";

export const Container = styled.div`
  margin-left: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  text-align: right;
  color: ${(props) => props.fontColor};
`;

export const Label = styled.label`
  cursor: pointer;
`;
